import EmptyResultOverlay from './EmptyResultOverlay';

export default EmptyResultOverlay;
